import { Field } from "react-final-form";

import { splitFieldProps } from "./splitFieldProps";
import { AmazonProductCard, ProductCard } from "../ProductCard";

function getProductCardComponent(variant = "default") {
    switch (variant) {
        case "default":
            return ProductCard;
        case "amazon":
            return AmazonProductCard;
        default:
            return ProductCard;
    }
}

export function ProductCardField(props) {
    const [fieldProps, productCardProps] = splitFieldProps(props);
    const FinalProductCard = getProductCardComponent(productCardProps.variant);

    return (
        <Field
            {...fieldProps}
            type="number"
            render={({ input, meta }) => (
                <FinalProductCard
                    {...productCardProps}
                    onAddToCart={() => input.onChange(1)}
                    onRemoveFromCart={() => input.onChange(0)}
                    onChangeAmount={(value) => input.onChange(value)}
                    selectedAmount={input.value}
                    {...input}
                >
                    {props.children}
                    {/* {meta.touched && meta.error && <span>{meta.error}</span>} */}
                </FinalProductCard>
            )}
        />
    );
}
